module.exports = ".hr-sample hr {\n  margin: 10px 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/divider/hr-divider/hr-divider.component.scss
// module id = ./src/app/features/divider/hr-divider/hr-divider.component.scss
// module chunks = main